/**
 * Shared KPI dashboard data table styling (all KPI Dashboard tabs: sky header, slate borders, zebra rows).
 * @see KpiProblemDashboardTab
 * @see KpiOperationalSummaryTables
 */
export const KPI_DASHBOARD_TABLE_TH =
  'sticky top-0 z-10 border border-slate-200 bg-[#e0f2fe] px-2 py-2 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-800 sm:text-xs';

/** Numeric / grouped metric columns (operational summary, matrix week columns). */
export const KPI_DASHBOARD_TABLE_TH_CENTER =
  'border border-slate-200 bg-[#e0f2fe] px-2 py-2 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-800 sm:text-xs';

/** Heatmap / matrix: label column (sticky left + top at scroll corner). */
export const KPI_DASHBOARD_TABLE_TH_STICKY_FIRST_COL =
  'sticky left-0 top-0 z-30 min-w-[11rem] border border-slate-200 bg-[#e0f2fe] px-3 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-800 shadow-[2px_0_4px_-2px_rgba(15,23,42,0.12)] sm:text-xs';

/** Heatmap / matrix: week or state columns with sticky header row. */
export const KPI_DASHBOARD_TABLE_TH_STICKY_TOP =
  'sticky top-0 z-[19] whitespace-nowrap border border-slate-200 bg-[#e0f2fe] px-2 py-2 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-800 sm:text-xs';

export const KPI_DASHBOARD_TABLE_TD = 'border border-slate-200 px-2 py-1.5 text-slate-800';

export const KPI_DASHBOARD_TABLE_TD_NUM = `${KPI_DASHBOARD_TABLE_TD} text-center tabular-nums`;

export function kpiDashboardTableRowClass(i: number): string {
  return i % 2 === 0 ? 'bg-white hover:bg-slate-50/80' : 'bg-slate-50/80 hover:bg-slate-50/80';
}

/** Primary identifier column (matches Problem details number link color). */
export const KPI_DASHBOARD_TABLE_TD_PRIMARY = `${KPI_DASHBOARD_TABLE_TD} font-medium text-[#2F5597]`;

/** Subtotal / emphasis footer rows (operational summary). */
export const KPI_DASHBOARD_TABLE_SUBTOTAL_ROW = 'bg-[#e0f2fe] font-semibold text-slate-900';
export const KPI_DASHBOARD_TABLE_GRAND_ROW = 'bg-[#e0f2fe] font-bold text-slate-900';

/** CI heatmap row highlight (cross-filter) — KPI-local, same accent family as headers. */
export const KPI_DASHBOARD_TABLE_ROW_SELECTED =
  'z-[1] bg-sky-50/90 ring-2 ring-inset ring-[#4472C4]/35 shadow-[inset_4px_0_0_0_rgb(125,211,252)]';

/** Drill-down ticket grid: primary header cell (rowSpan headers, SLA parent groups). */
export const KPI_DRILLDOWN_TH =
  'border border-slate-200 bg-[#e0f2fe] px-3 py-2 text-left align-middle text-[11px] font-semibold uppercase tracking-wide text-slate-800';

/** SLA column group headers (row 1). */
export const KPI_DRILLDOWN_SLA_GROUP_RESPONSE =
  'border border-slate-200 bg-sky-100/90 px-2 py-2 text-center text-xs font-semibold uppercase tracking-wide text-slate-800';
export const KPI_DRILLDOWN_SLA_GROUP_ONGOING =
  'border border-slate-200 bg-sky-200/70 px-2 py-2 text-center text-xs font-semibold uppercase tracking-wide text-slate-800';
export const KPI_DRILLDOWN_SLA_GROUP_RESOLUTION =
  'border border-slate-200 bg-sky-300/55 px-2 py-2 text-center text-xs font-semibold uppercase tracking-wide text-slate-800';

/** SLA sub-header row — three groups in one sky palette for scanability. */
export const KPI_DRILLDOWN_SLA_SUBTH_RESPONSE =
  'border border-slate-200 bg-sky-100/90 px-2 py-1.5 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-800 whitespace-nowrap';
export const KPI_DRILLDOWN_SLA_SUBTH_ONGOING =
  'border border-slate-200 bg-sky-200/70 px-2 py-1.5 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-800 whitespace-nowrap';
export const KPI_DRILLDOWN_SLA_SUBTH_RESOLUTION =
  'border border-slate-200 bg-sky-300/55 px-2 py-1.5 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-800 whitespace-nowrap';

/** SLA body column tint (matches header groups). */
export const KPI_DRILLDOWN_SLA_TD_RESPONSE = 'bg-sky-50/50';
export const KPI_DRILLDOWN_SLA_TD_ONGOING = 'bg-sky-100/35';
export const KPI_DRILLDOWN_SLA_TD_RESOLUTION = 'bg-sky-200/25';
